import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { REACT_APP_AUTH0_CLIENT_ID, REACT_APP_AUTH0_DOMAIN } from './common/constant';
import AuthProvider from './service/auth-provider/authProvider';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { history } from './jwt/_helpers';


const domain = REACT_APP_AUTH0_DOMAIN;
const clientId = REACT_APP_AUTH0_CLIENT_ID;

const onRedirectCallback = (appState) => {
  history.push(appState?.returnTo || window.location.pathname);
};


document.addEventListener('DOMContentLoaded', async () => {
  // const {publishableKey} = await fetch('/config').then((r) => r.json());
  const stripePromise = loadStripe('pk_test_0i0Up5UNkTgfCwiQPOkM6LoD001AjQYhUq');

  // ReactDOM.render(
  //   <React.StrictMode>
  //     <AuthProvider>
  //     <Elements stripe={stripePromise}>
  //       <App />
  //     </Elements>
  //     </AuthProvider>
  //   </React.StrictMode>,
  //   document.getElementById('root')
  // );


  ReactDOM.render(
    <Auth0Provider
    domain={domain}
    clientId={clientId}
    redirectUri={window.location.origin}
    buildLogoutUrl={window.location.origin}
    onRedirectCallback={onRedirectCallback}
  >
     <Elements stripe={stripePromise}>
    <App />
    </Elements>
  </Auth0Provider>,
    document.getElementById('root')
  );
});
